import DashboardApi from "@/api/dashboard/DashboardApi";

const state = {
  userInfo: {},
  userMenu: [],
  userStorage: '',
  userEncoding: {},
  liveCount: 0,
  assetCount: 0,
  ip: '',
  domainNotFound: false,
  trafficUsage: null,
  periodTrafficStart: null,
  periodTrafficEnd: null,
  errorMessage: null
};

const mutations = {
  SET_USER_INFO(state, payload) {
    state.userInfo = payload;
  },
  SET_USER_MENU(state, payload) {
    state.userMenu = payload;
  },
  SET_USER_STORAGE(state, payload) {
    state.userStorage = payload;
  },
  SET_USER_ENCODING(state, payload) {
    state.userEncoding = payload;
  },
  SET_LIVE_COUNT(state, payload) {
    state.liveCount = payload;
  },
  SET_IP(state, payload) {
    state.ip = payload;
  },
  SET_USER_ASSETCOUNT(state, payload) {
    state.assetCount = payload;
  },
  SET_DOMAIN_NOT_FOUND(state, value) {
    state.domainNotFound = value;
  },
  SET_TRAFFIC_USAGE(state, { trafficUsage, periodStart, periodEnd }) {
    state.trafficUsage = trafficUsage;
    state.periodTrafficStart = periodStart;
    state.periodTrafficEnd = periodEnd;
  },
  SET_ERROR_MESSAGE(state, message) {
    state.errorMessage = message;
  }
};

const actions = {
  // async userdata({ commit }) {
  //   try {
  //     const response = await DashboardApi.userdata();
  //     commit('SET_USER_INFO', response.userInfo);
  //     commit('SET_USER_MENU', response.userMenu);
  //     commit('SET_IP', response.ip);
  //   } catch (error) {
  //     console.error('Error fetching user data:', error);
  //   }
  // },
  // async livecount({ commit }) {
  //   try {
  //     const url = window.location.protocol + '//' + window.location.hostname;
  //     const response = await DashboardApi.livecount({ url });
  //     commit('SET_LIVE_COUNT', response.liveCount);
  //   } catch (error) {
  //     console.error('Error fetching user data:', error);
  //   }
  // },
  // async userstorage({ commit }) {
  //   try {
  //     const response = await DashboardApi.userstorage();
  //     commit('SET_USER_STORAGE', response.userStorage);
  //   } catch (error) {
  //     console.error('Error fetching user data:', error);
  //   }
  // },
  // async userencoding({ commit }) {
  //   try {
  //     const response = await DashboardApi.userencoding();
  //     commit('SET_USER_ENCODING', response.userEncoding);
  //   } catch (error) {
  //     console.error('Error fetching user data:', error);
  //   }
  // },
  // async userassetcount({ commit }) {
  //   try {
  //     const response = await DashboardApi.userassetcount();
  //     commit('SET_USER_ASSETCOUNT', response.assetCount);
  //   } catch (error) {
  //     console.error('Error fetching user data:', error);
  //   }
  // },
  async data({ commit }) {
    const url = window.location.protocol + '//' + window.location.host;
    const response = await DashboardApi.data({url});
    commit('SET_USER_INFO', response.userInfo);
    commit('SET_USER_MENU', response.userMenu);
    commit('SET_IP', response.ip);
    // commit('SET_USER_ASSETCOUNT', response.userInfo.assetCount);
    commit('SET_USER_ENCODING', response.userEncoding);
    commit('SET_USER_STORAGE', response.userStorage);
    commit('SET_LIVE_COUNT', response.liveCount);
  },
  async tencentData({ commit }) {
    try {
      const response = await DashboardApi.tencent();
      //console.log('response', response.tencent.original);
      const data = response.tencent.original;
      if (data.message === "Domain not found") {
        commit('SET_ERROR_MESSAGE', '도메인 등록이 필요합니다');
      } else {
        commit('SET_TRAFFIC_USAGE', {
          trafficUsage: data.traffic_usage + ' ' + (data.unit || 'GB'),
          periodStart: data.period?.start || null,
          periodEnd: data.period?.end || null
        });
      }
    } catch (error) {
      console.error('API call failed:', error);
      commit('SET_ERROR_MESSAGE', '도메인 등록이 필요합니다');
    }
  }
};

const getters = {

};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
